import { useEffect } from "react";
import { useInput } from "hooks";
import AutocompleteFreeText from "components/AutocompleteFreeText";
import { PHARMACY_SERVICE_PREDICTIVE_TEXT } from "config";

export const IncentivePharmacyServiceTextBuilder = ({
  value = "",
  onChange = () => { },
}) => {
  const val = useInput("");

  const handleUpdateValue = (v) => {
    onChange(`${v}`);
  };

  useEffect(() => {
    if (value) {
      val.setValue(value);
    }
    return () => { };
  }, [value]);

  return (
    <div className="p-2 d-flex justify-content-between align-items-center">
      <AutocompleteFreeText
        label='Free Text'
        value={value}
        data={PHARMACY_SERVICE_PREDICTIVE_TEXT}
        onChange={e => handleUpdateValue(e)}
      />
    </div>
  );
};